import { Component } from 'react';
import { APP_CONSTANTS } from '~/common/explicit-exports';
import { WRModals } from '~/components/wr-modals/wr-modals-container';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import AdminUtils from '../admin-utils';
import { apiDelete, hideLoader, showLoader, handleApiError } from '../../../common';
import AssetPickerEditAssetOptions from './edit-options/asset-picker-edit-asset-options';
import LearningObjectIconTextPair from './LearningObjectIconTextPair';

/**
 * Generic view for simple assets in the asset picker. Requires the asset to have id, type, name, order, and folderId.
 */

export default class AssetPickerAsset extends Component {
  render() {
    const { isEditable, asset, isActive } = this.props;

    // content imported from Go1 should not be editable
    const hasGo1Course = asset?.go1Course ? Object.keys(asset?.go1Course).length !== 0 : false;
    const hasGo1Playlist = asset?.hasGo1Playlist;
    const isGo1Content = hasGo1Course || hasGo1Playlist;
    const isContentProviderContent = asset.type === APP_CONSTANTS.CONTENT_PROVIDER_TOP_LEVEL_CONTENT_TYPE;
    const isAcademyCollectionContent = asset.type === AssetPickerTypes.ACADEMY_COLLECTION_CONTENT;

    const options =
      isEditable && !asset.udemy ? (
        <AssetPickerEditAssetOptions
          assetType={AssetPickerTypes.getDisplayName(isContentProviderContent ? asset.contentSource : asset.type)}
          renameCallback={this.onRenameClick}
          deleteCallback={this.onDeleteClick}
          hideEditButton={isGo1Content || isContentProviderContent}
        />
      ) : (
        ''
      );
    const moveIcon = isEditable ? (
      <img
        className="asset-picker-move-icon allow-draggable"
        src="/images/move_hover_icon.svg"
        width="9px"
        height="13px"
      />
    ) : (
      ''
    );

    const activeClass = isActive ? 'asset-picker-asset--active' : '';
    const { name, type } = asset;

    const learningObjectType = isContentProviderContent || isAcademyCollectionContent ? asset.contentSource : type;

    return (
      <div
        className={`asset-picker-asset ${activeClass}`}
        data-id={asset.id}
        data-type={type}
        data-order={asset.order}
        data-parent-id={asset.folderId}
      >
        <div className="asset-picker-asset--header">
          {moveIcon}
          <div className="asset-picker-asset--label" onClick={this.onLabelClick}>
            <LearningObjectIconTextPair
              type={learningObjectType}
              isActive={isActive}
              isHidden={asset.isHidden}
              text={name}
              subtext={asset.subtext}
              href={this.props.assetsAreLinks ? AssetPickerTypes.getItemAdminUrl(this.props.asset) : null}
              onPress={this.onLabelClick}
            />
          </div>
          {options}
        </div>
      </div>
    );
  }

  onLabelClick = () => {
    const assetCallbacks = this.props.selectableAssets;
    if (
      this.props.asset.type === APP_CONSTANTS.CONTENT_PROVIDER_TOP_LEVEL_CONTENT_TYPE &&
      assetCallbacks[this.props.asset.contentSource]
    ) {
      assetCallbacks[this.props.asset.contentSource](this.props.asset);
    } else if (assetCallbacks[this.props.asset.type]) {
      assetCallbacks[this.props.asset.type](this.props.asset);
    }
  };

  onRenameClick = (e) => {
    e.preventDefault();
    AdminUtils.promptForNewName(this.props.asset, this.props.updateCallback);
  };

  onDeleteClick = () => {
    const isContentProviderContent = this.props.asset.type === APP_CONSTANTS.CONTENT_PROVIDER_TOP_LEVEL_CONTENT_TYPE;
    const adminURLPath = AssetPickerTypes.getItemAdminUrl(this.props.asset);
    const promptText = isContentProviderContent
      ? `Are you sure you want to delete "${this.props.asset.title}?"`
      : `Are you sure you want to delete this ${AssetPickerTypes.getDisplayName(this.props.asset.type)}?`;

    WRModals.confirm(promptText, () => {
      showLoader();
      apiDelete(
        AssetPickerTypes.getUpdateItemUrl(this.props.asset),
        null,
        () => {
          hideLoader();
          this.props.updateCallback();
          if (window.location.pathname === adminURLPath) {
            window.location = '/admin/guides';
          }
        },
        handleApiError(),
      );
    });
  };
}
